exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spark-settings-tabs .nav-link[data-v-89ed0178] {\n    cursor: pointer;\n}\n.card[data-v-89ed0178] {\n    margin-bottom: 20px;\n}\n.rounded-circle[data-v-89ed0178] {\n    border-radius: 50%;\n}\n", ""]);

// exports
